import ListRoot, { Props } from './List'

export default function List(props: Props) {
  return <ListRoot {...props} />
}
